import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { LabelEffects } from './label.effects';
import { initialState, reducer } from './label.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('label', reducer, { initialState }),
    EffectsModule.forFeature([LabelEffects]),
  ],
  providers: [LabelEffects],
})
export class LabelStoreModule {}
